import { requestWithRetry } from '../axios'

export const postRedeemTicket = async (share_uid: string) => {
  const result = await requestWithRetry('order/share/redeem', 'post', {
    share_uid,
  })

  if (!result || typeof result !== 'object') {
    throw new Error('Redeem ticket returned invalid response')
  }

  return result
}
